/* eslint-disable no-unused-expressions */

import { Table, Pagination } from "antd";
import { AddHoliday } from "../../../components/modelpopup/AddHoliday";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { base_url } from "../../../base_urls";
import { getHolidayList } from "api/services/leave";
import { formatDateHandler2 } from "utils/common";
import { useSearchParams, useNavigate } from 'react-router-dom';
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import { SkeltonLoader } from "components/skeltonLoader";
import { Button } from "components/Button";
import { primaryRedGradient } from "utils/constants";

import { useMediaQuery } from "react-responsive";

const Holidays = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [view, setView] = useState(isMobile? "grid":"list")

  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})

  useEffect(() => {
    getHolidayList().then(response=>{
      setHolidays(response.data.results)
    })
  }, [pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters]);



  const columns = [
    // {
    //   title: "#",
    //   dataIndex: "id",
    //   render: (text) => <span>{text}</span>,
    //   sorter: (a, b) => a.id - b.id,
    // },
    {
      title: "Title",
      dataIndex: "name",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => true,
    },
    {
      title: "HolidayDate",
      dataIndex: "date",
      render: (text) => <span>{formatDateHandler2(text)}</span>,
      sorter: (a, b) => true,
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text) => <span>{text}</span>,
      // sorter: (a, b) => a.Day.length - b.Day.length,
    },
    // {
    //   title: "Action",
    //   render: () => (
    //     <div className="dropdown dropdown-action ">
    //       <Link
    //         to="#"
    //         className="action-icon dropdown-toggle"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <i className="material-icons">more_vert</i>
    //       </Link>
    //       <div className="dropdown-menu dropdown-menu-right">
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#edit_holiday"
    //         >
    //           <i className="fa fa-pencil m-r-5" /> Edit
    //         </Link>
    //         <Link
    //           className="dropdown-item"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#delete"
    //         >
    //           <i className="fa-regular fa-trash-can m-r-5" /> Delete
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    //   sorter: true,
    // },
  ];
  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
  }

  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    // setSearchParams({
    //     size: pageData?.pageSize,
    //     page: pageData?.page,
    //     sort_by: pageData?.sortBy || "",
    //     sort_type: pageData?.sortType || ""
    // })
    setPageSettings(pageData)
  };
  

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {holidays.map((holiday, index) => (
            <div
              className="col-12 col-sm-6 col-md-4 col-lg-3"
              key={holiday.id}
              style={{
                ...(isMobile ? { paddingLeft: "4px", paddingRight: "4px", marginBottom: "12px" } : { marginBottom: "16px" }),
                display: "flex"
              }}
            >
              <div className="card shadow-sm" style={{ 
                borderRadius: "8px", 
                border: "none",
                background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
                margin: 0,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                position: "relative",
                overflow: "hidden",
                cursor: "pointer",
                transition: "all 0.2s ease",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
              }}
              >
                <div className="card-body" style={{ 
                  padding: isMobile ? "12px" : "16px",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column"
                }}>
                  {/* Holiday Icon/Emoji */}
                  <div style={{ 
                    marginBottom: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80px",
                    background: "transparent",
                    borderRadius: "6px",
                    overflow: "hidden"
                  }}>
                    <i className="la la-calendar-o" style={{ 
                      fontSize: "48px",
                      color: "#d3001a",
                      opacity: 0.8
                    }}></i>
                  </div>

                  {/* Holiday Name - Main Highlight */}
                  <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ 
                      fontSize: isMobile ? "15px" : "16px",
                      fontWeight: "600",
                      color: "#1f2937",
                      marginBottom: "8px",
                      lineHeight: "1.3",
                      textAlign: "center"
                    }}>
                      {holiday.name || "Untitled Holiday"}
                    </h4>
                  </div>

                  {/* Holiday Details */}
                  <div style={{
                    borderTop: "1px solid #e5e7eb",
                    paddingTop: "12px",
                    marginBottom: "12px",
                    flex: 1
                  }}>
                    <div className="row g-2">
                      {holiday?.date && (
                        <div className="col-12">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            Date
                          </div>
                          <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(holiday.date)}
                          </div>
                        </div>
                      )}
                      {holiday?.description && (
                        <div className="col-12">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            Description
                          </div>
                          <div style={{ 
                            fontSize: "12px", 
                            color: "#374151", 
                            fontWeight: "400",
                            lineHeight: "1.5",
                            wordBreak: "break-word"
                          }}>
                            {holiday.description}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Holidays"
            title="Dashboard"
            subtitle="Holidays"
            modal="#add_holiday"
            name="Add Holiday"
            view={view}
            setView={setView}
          />
          <div className="d-flex justify-content-end align-items-end" >

          </div>

          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
              {
                view == "grid" ?
                <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            className="btn btn-primary"
                            label="Load More"
                            style={{ background: primaryRedGradient, border: "none" }}
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
            : (
            <div className="row">
              <div className="col-12">
                <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                  <style>{`
                    .modern-table .ant-table-tbody > tr {
                      background-color: #ffffff !important;
                    }
                    .modern-table .ant-table-tbody > tr:hover > td {
                      background-color: #f5f5f5 !important;
                    }
                    .modern-table .ant-table-thead > tr > th {
                      background-color: #f8f9fa !important;
                      font-weight: 600;
                      color: #333;
                      border-bottom: 2px solid #e0e0e0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-tbody > tr > td {
                      border-bottom: 1px solid #f0f0f0;
                      padding: 10px 12px;
                      font-size: 13px;
                    }
                    .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                      border-top: 1px solid #f0f0f0;
                      background-color: #ffffff;
                      border-bottom-left-radius: 12px;
                      border-bottom-right-radius: 12px;
                    }
                  `}</style>
                  <div className="table-responsive" style={{ overflowX: "auto" }}>
                    <Table
                      className="mb-0 modern-table"
                      style={{ 
                        borderRadius: "12px",
                        minWidth: "100%"
                      }}
                      scroll={{ x: "max-content" }}
                      columns={columns}
                      dataSource={holidays}
                      rowKey={(record) => record.id}
                      loading={loading}
                      pagination={{
                        total: pageSettings?.total,
                        pageSize: pageSettings?.pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: pageSizeOptions,
                        itemRender: itemRender,
                        position: "right",
                        current: pageSettings?.page,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total} items`,
                        style: { padding: "16px" }
                      }}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            )

              }
             
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      <AddHoliday />
      <DeleteModal Name="Delete Holiday" />
    </>
  );
};

export default Holidays;
